module.exports = __webpack_public_path__ + "static/media/thumbnail.fc006b12.jpg";